import { Routes } from '@angular/router';
import { FramePage } from './domains/frame/frame.page';
import { CHILDREN_ROUTES } from './app-routing-features.routes';
import { authChildGuard, authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        component: FramePage,
        canActivate: [authGuard],
        canActivateChild: [authChildGuard],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            ...CHILDREN_ROUTES
        ]
    },
    {
        path: '**',
        redirectTo: 'home'
    }
];
